import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    header: {
        id: 'buy.page.header',
        defaultMessage: 'Buy crypto',
    },
})
